export default (operationDefinition, allDefinitions) => ({
    name: "simple_linked_field",
    definition: {
        init: function () {
            this.jsonInit({
                "message0": 'simple linked field %1 %2',
                "args0": [
                    {
                        "type": "field_dropdown",
                        "name": "LINK_DEFINITION",
                        "options": [
                            ["NULL", "null"],
                            ...Object.keys(operationDefinition.model.dynaProperties)
                                .map(key => operationDefinition.model.dynaProperties[key])
                                .map(param => {
                                    if (param.details.type === 'ENTITY_REFERENCE') {
                                        return [param.name, param.name]
                                    }
                                })
                                .filter(param => param),
                            [
                                "name",
                                "id"
                            ]
                        ]
                    },
                    {
                        "type": "input_value",
                        "name": "FIELD",
                        "check": "String"
                    },
                ],
                "inputsInline": true,
                "output": null,
                "colour": 4.5,
                "tooltip": "Creates cash event with specified parameters",
                "helpUrl": "http://www.w3schools.com/jsref/jsref_length_string.asp"
            });
        }
    },
    codeGenerator: (blocklyInstance) => function (block) {
        let linkDefinitionId = block.getFieldValue("LINK_DEFINITION");
        let param = blocklyInstance.JavaScript.valueToCode(block, "FIELD", blocklyInstance.JavaScript.ORDER_ATOMIC);
        console.log(param)
        if(param == '\'name\'') {
            return [`linkedOperations.get('${linkDefinitionId}').name`, blocklyInstance.JavaScript.ORDER_NONE];
        }
        else {
            return [`linkedOperations.get('${linkDefinitionId}').content.values.get(${param})`, blocklyInstance.JavaScript.ORDER_NONE];
        }
        ;
    }
})
